

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CitySetup } from "../../components/CitySetup/CitySetup";


export const CityPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="City"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/City/list" },
        { text: "City", navigateTo: "/city" }
      ]}
      mainContents={<CitySetup />}
    />
  );
};
